import * as React from 'react';
import styled from 'styled-components';
import GroupButton, { GroupButtonConfig } from './GroupButton';

interface Props<T extends string> {
  buttonConfigs: GroupButtonConfig<T>[];
  theme?: 'default' | 'grey';
  paddingRem?: number;
  dataTest?: string;
}

export function ButtonGroup<T extends string>({ buttonConfigs, paddingRem, theme, dataTest }: Props<T>) {
  return (
    <StyledGroupButtonWrapper className="button_group" data-test={dataTest ?? 'button_group'}>
      {buttonConfigs.map((config, index) => (
        <GroupButton
          theme={theme || 'default'}
          key={config.id}
          buttonConfig={config}
          index={index}
          numSiblings={buttonConfigs.length}
          paddingRem={paddingRem}
        />
      ))}
    </StyledGroupButtonWrapper>
  );
}

export default ButtonGroup;

const StyledGroupButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border: thin solid #b9c0c7;
  border-radius: 3px;
`;
